// extracted by mini-css-extract-plugin
export default {"add":"AlbumItem_add__bFLev","albumBox":"AlbumItem_albumBox__9HgR9","album":"AlbumItem_album__6kWPT","photo":"AlbumItem_photo__6xCU1","userIcon":"AlbumItem_userIcon__Fm-Fd"};